export default "__VITE_ASSET__DS8tgr7V__"